import Spinner from "../../assets/gifs/throbber-48x48.gif";

const Throbber: React.FC = () => {
  return (
    <img
      src={Spinner}
      style={{ height: "48px", width: "48px" }}
      alt="loading..."
    />
  );
};

export default Throbber;
